import { IPaginationData, IResolve } from '@/types/communal.types';
import {
  IAreaItem, IDispatchAlertCustomColumnDto, IDispatchAlertSearchParams, IGetDispatchAlertConfigDto, IGetDispatchAlertListDto,
  IUpdateDispatchAlertConfigParams, IGetDispatchAlertMapListDto, IGetDispatchAlertDetailDto, ICreateDispatchAlertParams, IUpdateDispatchAlertParams, IGetDispatchAlertCustomerInfoDto, IGetDispatchAlertCustomerParams, IGetDispatchAlertCustomerItemDto, IGetCustomerOrderInfoParams, IGetCustomerOrderInfoDto, IGetDispatchAlertOptionsParams, IDispatchAlertOptionItem,
} from '@/types/earlyWarning';
import { IPageListResolve } from '@/types/table.base.types';
import { api } from './api';

/**
 * 获取美国州和城市
 * @returns
 */
export const getUsStateAndCity = async (): Promise<IResolve<IAreaItem[]>> => {
  return await api.get('/DispatchAlert/GetUsStateAndCity');
};
/**
 * 获取预警设置
 * @returns
 */
export const getDispatchAlertConfig = async (): Promise<IResolve<IGetDispatchAlertConfigDto>> => {
  return await api.get('/DispatchAlert/GetDispatchAlertConfig');
};

/**
 * 修改预警设置
 * @param data
 * @returns
 */
export const updateDispatchAlertConfig = async (data: IUpdateDispatchAlertConfigParams): Promise<IResolve<null>> => {
  return await api.post('/DispatchAlert/CreateOrUpdateDispatchAlertConfig', data);
};

/**
 * 获取预警列表
 * @returns
 */
export const getDispatchAlertList = async (params: IDispatchAlertSearchParams)
: Promise<IResolve<IPaginationData & {Items: IGetDispatchAlertListDto[]}>> => {
  return await api.get('/DispatchAlert/GetDispatchAlertList', { params });
};

/**
 * 获取预警数量
 * @returns
 */
export const getActiveAlertCount = async (): Promise<IResolve<number>> => {
  return await api.get('/DispatchAlert/GetActiveAlertCount');
};

/**
 * 获取预警列表表格自定义column数据
 * @returns
 */
export const getAlertListCustomField = async (): Promise<IResolve<IDispatchAlertCustomColumnDto>> => {
  return await api.get('/DispatchAlert/GetAlertListCustomField');
};

/**
 * 创建或更新预警列表表格自定义column数据
 * @param data
 * @returns
 */
export const createOrUpdateListCustomField = async (data: IDispatchAlertCustomColumnDto): Promise<IResolve<null>> => {
  return await api.post('/DispatchAlert/CreateOrUpdateListCustomField', data);
};

/**
 * 获取预警列表(地图模式)
 * @returns
 */
export const getDispatchAlertMapList = async (params: IDispatchAlertSearchParams): Promise<IResolve<IPaginationData & {Items: IGetDispatchAlertMapListDto[]}>> => {
  return await api.get('/DispatchAlert/GetDispatchAlertMapList', { params });
};

/**
 * 获取预警的客户数据
 * @param params
 * @returns
 */
export const getDispatchAlertCustomers = async (params: IGetDispatchAlertCustomerParams): Promise<IResolve<IPaginationData & {Items: IGetDispatchAlertCustomerItemDto[]}>> => {
  return await api.get('/DispatchAlert/GetDispatchAlertCustomer', { params });
};

/**
 * 获取预警详情
 * @param alertId
 * @returns
 */
export const getDispatchAlertDetail = async (alertId: string): Promise<IResolve<IGetDispatchAlertDetailDto>> => {
  return await api.get('/DispatchAlert/GetDispatchAlertDetail', {
    params: {
      AlertId: alertId,
    },
  });
};

/**
 * 创建预警
 * @param data
 * @returns
 */
export const createDispatchAlert = async (data: ICreateDispatchAlertParams): Promise<IResolve<null>> => {
  return await api.post('/DispatchAlert/CreateDispatchAlert', data);
};

/**
 * 修改预警
 * @param data
 * @returns
 */
export const updateDispatchAlert = async (data: IUpdateDispatchAlertParams): Promise<IResolve<null>> => {
  return await api.put('/DispatchAlert/UpdateDispatchAlert', data);
};

/**
 * 删除预警
 * @param alertId
 * @returns
 */
export const deleteDispatchAlert = async (alertId: string): Promise<IResolve<null>> => {
  return await api.delete('/DispatchAlert/DeleteDispatchAlert', {
    params: {
      AlertId: alertId,
    },
  });
};

/**
 * 获取预警客户信息
 * @param alertId
 * @returns
 */
export const getDispatchAlertCustomerInfo = async (alertId: string): Promise<IResolve<IGetDispatchAlertCustomerInfoDto>> => {
  return await api.get('/DispatchAlert/GetDispatchAlertCustomerInfo', {
    params: {
      AlertId: alertId,
    },
  });
};

/**
 * 获取客户信息
 * @param params
 * @returns
 */
export const getCustomerOrderInfo = async (params: IGetCustomerOrderInfoParams): Promise<IResolve<IGetCustomerOrderInfoDto>> => {
  return await api.get('/DispatchAlert/GetCustomerOrderInfo', { params });
};

/**
 * 获取预警选项数据
 * @param params
 * @returns
 */
export const getDispatchAlertOptions = async (params: IGetDispatchAlertOptionsParams): Promise<IPageListResolve<IDispatchAlertOptionItem>> => {
  return await api.get('/DispatchAlert/GetDispatchAlertOptions', { params });
};
